// extracted by mini-css-extract-plugin
export default {"statsContainer":"stats-container_statsContainer__XAyzJ"};